/**
 * Conditionally loads Next.js Image component.
 *
 * Extracted into its own module so vitest can mock it via vi.mock()
 * (vitest cannot intercept bare CJS require() for external packages).
 */
let _NextImage = null;
try {
    _NextImage = require('next/image');
}
catch {
    // Next.js not available — component falls back to <img>
}
export const NextImage = _NextImage;
